import { CobuText, CobuStack, CobuInput } from '@cobu/ui';
import { Strings } from '../../constants/Strings';

interface SkillInputProps {
  taskNumber: number;
  value: string;
  placeholder: string;
  onChangeText: (text: string) => void;
}

export default function SkillInput({ taskNumber, value, placeholder, onChangeText }: SkillInputProps) {
  const strings = Strings.get();

  return (
    <CobuStack mt="$2" w="100%">
      <CobuText 
        variant="body" 
        color="$cobuPink" 
        fontSize={12}
        fontWeight="bold"
        mb="$2"
      >
        {strings.profile.components.managePublicProfile.skillsSection.taskNumber}{taskNumber}:
      </CobuText>
      <CobuInput
        placeholder={placeholder}
        placeholderTextColor="$borderColorLight"
        value={value}
        maxLength={100}
        onChangeText={onChangeText}
        br="$0"
        bc="transparent"
        borderBottomWidth={1}
        borderBottomColor="$black"
        paddingBottom={6}
        borderLeftWidth={0}
        borderRightWidth={0}
        borderTopWidth={0}
        borderColor="transparent"
        fontSize="$3"
      />
    </CobuStack>
  );
} 